import {
    Checkbox,
    Hidden,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@material-ui/core';
import React from 'react';
import OutputDate from './OutputDate';
import DataHora from './DataHora';
import Assinante from './Assinante';

const { DateTime } = require('luxon');

const Cartelas = ({
    value,
    onSelecionar,
    usuario,
    btnRadio,
    produtos,
    perfilCompartilhado,
    cartela,
}) => {
    const [selected, setSelected] = React.useState([]);
    const find = (id) => value.find((e) => e.id === id);
    const isSelected = (id) => !!selected.find((e) => e.id === id);
    const onSelectChange = (id) => (e, checked) => {
        if (checked) setSelected([...selected, find(id)]);
        else setSelected(selected.filter((e) => e.id !== id));
    };

    React.useEffect(() => {
        onSelecionar(selected);
    }, [selected, onSelecionar]);

    function verificaPedido(pedido) {
        const existePedido = produtos.some((produto) => {
            if (produto.pedido === pedido) {
                return true;
            }
            return false;
        });
        return existePedido;
    }

    function verificaDataRetirada(pedido) {
        const dataExiste = produtos.some((produto) => {
            if (produto.pedido === pedido) {
                const dateTimeInicioAgendamento = new Date(
                    produto.dataInicioAgendamento,
                );
                const dateTimeFimAgendamento = new Date(
                    produto.dataFimAgendamento,
                );
                if (
                    DateTime.fromJSDate(dateTimeInicioAgendamento, {
                        zone: 'America/Sao_Paulo',
                    }) <= DateTime.now() &&
                    DateTime.fromJSDate(dateTimeFimAgendamento, {
                        zone: 'America/Sao_Paulo',
                    }) >= DateTime.now()
                ) {
                    return true;
                }
            }
            return false;
        });
        return dataExiste;
    }

    function cartelasRetiradas() {
        if (value.length === 0) return false;
        const data = value.some((cartela) => {
            if (!!cartela?.dataRetirada) return false;
            return true;
        });
        return data;
    }

    const TotalTableRow = () => (
        <TableRow>
            <Hidden smDown>
                <TableCell colSpan="4">TOTAL À RETIRAR</TableCell>
            </Hidden>
            <Hidden mdUp>
                <TableCell colSpan="2">TOTAL À RETIRAR</TableCell>
            </Hidden>
            <TableCell style={{ fontSize: '1.5em', fontWeight: 800 }}>
                {total}
            </TableCell>
        </TableRow>
    );

    const TableHeader = () => (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">#</TableCell>
                <Hidden smDown>
                    <TableCell>Produto</TableCell>
                    <TableCell>Quantidade</TableCell>
                    <TableCell>Pedido</TableCell>
                    <TableCell>Data da Compra</TableCell>
                </Hidden>
                <Hidden mdUp>
                    <TableCell>Produto</TableCell>
                    <TableCell>Qt</TableCell>
                </Hidden>
            </TableRow>
        </TableHead>
    );

    const total = selected.reduce(
        (total, { quantidade }) => total + quantidade,
        0,
    );

    function retiradoPor(produtos, pedido) {
        return (
            produtos.find((produto) => produto.pedido === pedido)
                ?.retiradoPor?.trim() || 'Não informado'
        );
    }

    return value.length === 0 ? (
        <Typography variant="overline">Nenhuma cartela disponível</Typography>
    ) : btnRadio !== 2 ? (
        <>
            {Object.keys(perfilCompartilhado).length !== 0 && (
                <Assinante value={perfilCompartilhado} />
            )}
            <TableContainer style={{ paddingBottom: '10px' }}>
                <Table>
                    <TableHeader />
                    <TableBody>
                        {value.map(
                            ({
                                id,
                                pedido,
                                podeRetirar,
                                dataPedido,
                                dataRetirada,
                                listaPrecoItemNomeKit,
                                nomeItem,
                                quantidade,
                            }) => (
                                <TableRow key={id}>
                                    <TableCell padding="checkbox">
                                        {
                                            <Checkbox
                                                checked={
                                                    !!dataRetirada ||
                                                    isSelected(id)
                                                }
                                                onChange={onSelectChange(id)}
                                                disabled={!podeRetirar}
                                            />
                                        }
                                    </TableCell>

                                    <Hidden smDown>
                                        <TableCell>
                                            <div>
                                                {listaPrecoItemNomeKit ||
                                                    nomeItem}
                                            </div>
                                            {dataRetirada && (
                                                <Typography variant="caption">
                                                    RETIRADO:{' '}
                                                    <DataHora
                                                        value={dataRetirada}
                                                    />
                                                    <br />
                                                    POR:{' '}
                                                    {retiradoPor(
                                                        produtos,
                                                        pedido,
                                                    )}
                                                </Typography>
                                            )}
                                        </TableCell>

                                        <TableCell>{quantidade}</TableCell>
                                        <TableCell>{pedido}</TableCell>

                                        <TableCell>
                                            {DateTime.fromISO(dataPedido, {
                                                locale: 'pt-BR',
                                            }).toLocaleString(
                                                DateTime.DATE_FULL,
                                            )}
                                        </TableCell>
                                    </Hidden>

                                    <Hidden mdUp>
                                        <TableCell>
                                            <div>
                                                {listaPrecoItemNomeKit ||
                                                    nomeItem}
                                            </div>
                                            {dataRetirada && (
                                                <Typography variant="caption">
                                                    RETIRADO:{' '}
                                                    <DataHora
                                                        value={dataRetirada}
                                                    />
                                                    <br />
                                                    POR:{' '}
                                                    {retiradoPor(
                                                        produtos,
                                                        pedido,
                                                    )}
                                                </Typography>
                                            )}
                                        </TableCell>
                                        <TableCell>{quantidade}</TableCell>
                                    </Hidden>
                                </TableRow>
                            ),
                        )}
                        <TotalTableRow />
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    ) : (
        <>
            {!cartelasRetiradas() ? (
                <Typography variant="overline">
                    {cartela === 'principal' &&
                        'BBB Nenhuma cartela disponível'}
                    {cartela !== 'principal' &&
                        'Nenhuma cartela compartilhada disponível'}
                </Typography>
            ) : (
                value.map(
                    ({
                        id,
                        pedido,
                        podeRetirar,
                        dataPedido,
                        dataRetirada,
                        listaPrecoItemNomeKit,
                        nomeItem,
                        quantidade,
                    }) =>
                        (verificaPedido(pedido) &&
                            verificaDataRetirada(pedido) &&
                            podeRetirar) ||
                        (!dataRetirada && (
                            <>
                                {Object.keys(perfilCompartilhado).length !==
                                    0 && (
                                    <Assinante value={perfilCompartilhado} />
                                )}
                                <TableContainer
                                    style={{ paddingBottom: '10px' }}
                                >
                                    <Table>
                                        <TableHeader />
                                        <TableBody>
                                            <TableRow key={id}>
                                                <TableCell padding="checkbox">
                                                    {
                                                        <Checkbox
                                                            checked={
                                                                !!dataRetirada ||
                                                                isSelected(id)
                                                            }
                                                            onChange={onSelectChange(
                                                                id,
                                                            )}
                                                            disabled={
                                                                !podeRetirar
                                                            }
                                                        />
                                                    }
                                                </TableCell>
                                                <Hidden smDown>
                                                    <TableCell>
                                                        <div>
                                                            {listaPrecoItemNomeKit ||
                                                                nomeItem}
                                                        </div>
                                                        {dataRetirada && (
                                                            <Typography variant="caption">
                                                                RETIRADO:{' '}
                                                                <DataHora
                                                                    value={
                                                                        dataRetirada
                                                                    }
                                                                />
                                                                <br />
                                                                POR:{' '}
                                                                {retiradoPor(
                                                                    produtos,
                                                                    pedido,
                                                                )}
                                                            </Typography>
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        {quantidade}
                                                    </TableCell>
                                                    <TableCell>
                                                        {pedido}
                                                    </TableCell>
                                                    <TableCell>
                                                        <OutputDate
                                                            value={dataPedido}
                                                        />
                                                    </TableCell>
                                                </Hidden>
                                                <Hidden mdUp>
                                                    <TableCell>
                                                        <div>
                                                            {listaPrecoItemNomeKit ||
                                                                nomeItem}
                                                        </div>
                                                        {dataRetirada && (
                                                            <Typography variant="caption">
                                                                RETIRADO:{' '}
                                                                <DataHora
                                                                    value={
                                                                        dataRetirada
                                                                    }
                                                                />
                                                                <br />
                                                                POR:{' '}
                                                                {retiradoPor(
                                                                    produtos,
                                                                    pedido,
                                                                )}
                                                            </Typography>
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        {quantidade}
                                                    </TableCell>
                                                </Hidden>
                                            </TableRow>
                                            <TotalTableRow />
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </>
                        )),
                )
            )}
        </>
    );
};

Cartelas.defaultProps = {
    value: [],
    onSelecionar: console.warn,
    usuario: {},
};

export default Cartelas;
